import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import VirtualizedSelect from 'react-virtualized-select';
import { graphOptions } from './options/options';
import { updateLaneManagementKPIGraph,
         updateLongitudinalMotionKPIGraph,
         updateSafeDrivingKPIGraph,
         updateEgoVelocityKPIGraph,
         updateL1LateralAccelerationKPIGraph,
         updateL1LateralJerkKPIGraph,
         updateL1LongitudinalDecelerationKPIGraph,
         updateL1LongitudinalAccelerationKPIGraph,
         updateL1LongitudinalJerkKPIGraph,
         updateL1LongitudinalVelocityDropKPIGraph,
         updateL0CollisionCheckKPIGraph,
         updateL0LateralSafeDistanceKPIGraph,
         updateL0LongitudinalSafeDistanceKPIGraph,
         updateL0OffRoadCheckKPIGraph,
         updateL0LaneMarkingCheckKPIGraph,
         updateL0IndicatorCheckingKPIGraph,
         updateL0SpeedLimitCheckKPIGraph,
         updateL0FalseIndicatorCheckKPIGraph,
         updateRSSLongitudinalSafeCheckKPIGraph,
         updateRSSLateralLeftSafeCheckKPIGraph,
         updateRSSLateralRightSafeCheckKPIGraph } from './../../../../actions/closeLoop/kpiDashboard/dashboardGraphs/dashboardGraphActions';
import LaneManagementKPI from './kpi/laneManagementKPI';
import LongitudinalMotionKPI from './kpi/longitudinalMotion/longitudinalMotionKPI';
import SafeDrivingKPI from './kpi/safeDriving/safeDrivingKPI';
import EgoVelocityKPI from './kpi/egoVelocity/egoVelocityKPI';

import L1LateralAccelerationKPI from './kpi/levelOne/lateralAcceleration/lateralAccelerationKPI';
import L1LateralJerkKPI from './kpi/levelOne/lateralJerk/lateralJerkKPI';
import L1LongitudinalAccelerationKPI from './kpi/levelOne/longitudinalAcceleration/longitudinalAccelerationKPI';
import L1LongitudinalDecelerationKPI from './kpi/levelOne/longitudinalDeceleration/longitudinalDecelerationKPI';
import L1LongitudinalJerkKPI from './kpi/levelOne/longitudinalJerk/longitudinalJerkKPI';
import L1LongitudinalVelocityDropKPI from './kpi/levelOne/longitudinalVelocityDrop/longitudinalVelocityDropKPI';

import L0CollisionCheckKPI from './kpi/levelZero/collisionCheck/collisionCheckKPI';
import L0LateralSafeDistanceKPI from './kpi/levelZero/lateralSafeDistance/lateralSafeDistanceKPI';
import L0LongitudinalSafeDistanceKPI from './kpi/levelZero/longitudinalSafeDistance/longitudinalSafeDistanceKPI';
import L0OffRoadCheckKPI from './kpi/levelZero/offRoadCheck/offRoadCheckKPI';
import L0LaneMarkingCheckKPI from './kpi/levelZero/laneMarkingCheck/laneMarkingCheckKPI';
import L0IndicatorCheckKPI from './kpi/levelZero/indicatorCheck/indicatorCheckingKPI';
import L0SpeedLimitCheckKPI from './kpi/levelZero/speedLimitCheck/speedLimitCheckKPI';
import L0FalseIndicatorCheckKPI from './kpi/levelZero/falseIndicatorCheck/falseIndicatorCheckKPI';

import RSSLongitudinalSafeCheckKPI from './kpi/rss/longitudinalSafeCheck/longitudinalSafeCheckKPI';
import RSSLateralLeftSafeCheckKPI from './kpi/rss/lateralLeftSafeCheck/lateralLeftSafeCheckKPI';
import RSSLateralRightSafeCheckKPI from './kpi/rss/lateralRightSafeCheck/lateralRightSafeCheckKPI';
// Importing CSS for react-virtualized-select
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
import PropTypes from 'prop-types';

function VisualizationTabs (props) {
    const [graphOne, setGraphOne] = useState('');
    const [graphTwo, setGraphTwo] = useState('');

    useEffect(() => {
        setGraphOne('');
        setGraphTwo('');
    }, [props.bench, props.testRunId, props.scenarioUUID])

    const loadTJAKPIGraph = (kpi, payload) => {
        loadTJALaneManagementKPIGraph(kpi, payload);
        loadTJALongitudinalMotionKPIGraph(kpi, payload);
        loadTJASafeDrivingKPIGraph(kpi, payload);
        loadTJAEgoVelocityKPIGraph(kpi, payload);
    };

    const loadTJALaneManagementKPIGraph = (kpi, payload) => {
        if (kpi.value === 'lane_management_kpi') {
            if((props.laneAvailability.availability === 0 && props.laneAvailability.nonAvailability === 0) &&
            (props.laneOffset.xAxis.length === 0 && props.laneOffset.yAxis.length === 0 )) {
                    props.updateLaneManagementKPI(payload);
            }
        }
    };

    const loadTJALongitudinalMotionKPIGraph = (kpi, payload) => {
        if (kpi.value === 'longitudinal_motion_kpi') {
            if((props.jerks.xAxis.length === 0 && props.jerks.yAxis.length === 0) &&
            (props.acceleration.xAxis.length === 0 && props.acceleration.yAxis.length === 0)) {
                props.updateLongitudinalMotionKPI(payload);
            }
        }
    };

    const loadTJASafeDrivingKPIGraph = (kpi, payload) => {
        if(kpi.value === 'safe_driving_kpi') {
            if((props.timeToCollision.xAxis.length === 0 && props.timeToCollision.yAxis.length === 0) &&
            (props.relativeDistance.xAxis.length === 0 && props.relativeDistance.yAxis.length === 0)) {
                props.updateSafeDrivingKPI(payload);
            }
        }
    };

    const loadTJAEgoVelocityKPIGraph = (kpi, payload) => {
        if(kpi.value === 'ego_velocity') {
            if((props.egoVelocity.xAxis.length === 0 && props.egoVelocity.yAxis.length === 0) &&
            (props.targetVelocity.xAxis.length === 0 && props.targetVelocity.yAxis.length === 0)) {
                props.updateEgoVelocityKPI(payload);
            }
        }
    };

    const loadLevel1KPIGraph = (kpi, payload) => {
        loadLevel1LateralAccelerationKPIGraph(kpi, payload);
        loadLevel1LateralJerkKPI(kpi, payload);
        loadLevel1LongitudinalDecelKPIGraph(kpi, payload);
        loadLevel1LongitudinalAccelKPIGraph(kpi, payload);
        loadLevel1LongitudinalJerkKPIGraph(kpi, payload);
        loadLevel1LongitudinalVelocityDropKPIGraph(kpi, payload);
    };

    const loadLevel1LateralAccelerationKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l1_lateral_acceleration_kpi') {
            if((props.levelOne.l1LateralAcceleration.egoAcceleration.xAxis.length === 0 &&
                props.levelOne.l1LateralAcceleration.egoAcceleration.yAxis.length === 0) && (
                props.levelOne.l1LateralAcceleration.kpiPass.xAxis.length === 0 &&
                props.levelOne.l1LateralAcceleration.kpiPass.yAxis.length === 0 )) {
                    props.updateL1LateralAccelerationKPI(payload);
                }
        }
    };

    const loadLevel1LateralJerkKPI = (kpi, payload) => {
        if(kpi.value === 'l1_lateral_jerk_kpi') {
            if((props.levelOne.l1LateralJerk.lateralJerk.xAxis.length === 0 &&
                props.levelOne.l1LateralJerk.lateralJerk.yAxis.length === 0) && (
                props.levelOne.l1LateralJerk.kpiPass.xAxis.length === 0 &&
                props.levelOne.l1LateralJerk.kpiPass.yAxis.length === 0 )) {
                    props.updateL1LateralJerkKPI(payload);
                }
        }
    };

    const loadLevel1LongitudinalDecelKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l1_longitudinal_deceleration_kpi') {
            if((props.levelOne.l1LongitudinalDeceleration.egoAccelerationX.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalDeceleration.egoAccelerationX.yAxis.length === 0) && (
                props.levelOne.l1LongitudinalDeceleration.kpiPass.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalDeceleration.kpiPass.yAxis.length === 0 )) {
                    props.updateL1LongitudinalDecelerationKPI(payload);
                }
        }
    };

    const loadLevel1LongitudinalAccelKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l1_longitudinal_acceleration_kpi') {
            if((props.levelOne.l1LongitudinalAcceleration.egoAccelerationX.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalAcceleration.egoAccelerationX.yAxis.length === 0) && (
                props.levelOne.l1LongitudinalAcceleration.kpiPass.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalAcceleration.kpiPass.yAxis.length === 0 )) {
                    props.updateL1LongitudinalAccelerationKPI(payload);
                }
        }
    };

    const loadLevel1LongitudinalJerkKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l1_longitudinal_jerk_kpi') {
            if((props.levelOne.l1LongitudinalJerk.longitudinalJerk.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalJerk.longitudinalJerk.yAxis.length === 0) && (
                props.levelOne.l1LongitudinalJerk.kpiPass.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalJerk.kpiPass.yAxis.length === 0 )) {
                    props.updateL1LongitudinalJerkKPI(payload);
                }
        }
    };

    const loadLevel1LongitudinalVelocityDropKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l1_longitudinal_velocity_drop_kpi') {
            if((props.levelOne.l1LongitudinalVelocityDrop.egoVelocityXDrop.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalVelocityDrop.egoVelocityXDrop.yAxis.length === 0) && (
                props.levelOne.l1LongitudinalVelocityDrop.egoAccelerationX.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalVelocityDrop.egoAccelerationX.yAxis.length === 0) && (
                props.levelOne.l1LongitudinalVelocityDrop.kpiPass.xAxis.length === 0 &&
                props.levelOne.l1LongitudinalVelocityDrop.kpiPass.yAxis.length === 0 )) {
                    props.updateL1LongitudinalVelocityDropKPI(payload);
                }
        }
    };

    const loadLevel0KPIGraph = (kpi, payload) => {
        loadLevel0CollisionKPIGraph(kpi, payload);
        loadLevel0LateralKPIGraph(kpi, payload);
        loadLevel0LongitudinalKPIGraph(kpi, payload);
        loadLevel0OffRoadKPIGraph(kpi, payload);
        loadLevel0LaneMarkingKPIGraph(kpi, payload);
        loadLevel0IndicatorCheckingKPIGraph(kpi, payload);
        loadLevel0SpeedLimitKPIGraph(kpi, payload);
        loadLevel0FalseIndicatorKPIGraph(kpi, payload);
    };

    const loadLevel0CollisionKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_collision_check_kpi') {
            if((props.levelZero.l0CollisionCheck.longitudinalGapWithTV.xAxis.length === 0 &&
                props.levelZero.l0CollisionCheck.longitudinalGapWithTV.yAxis.length === 0) && (
                props.levelZero.l0CollisionCheck.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0CollisionCheck.kpiPass.yAxis.length === 0)) {
                    props.updateL0CollisionCheckKPI(payload);
                }
        }
    };

    const loadLevel0LateralKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_lateral_safe_distance_kpi') {
            if((props.levelZero.l0LateralSafeDistance.lateralGapWithTV.xAxis.length === 0 &&
                props.levelZero.l0LateralSafeDistance.lateralGapWithTV.yAxis.length === 0) && (
                props.levelZero.l0LateralSafeDistance.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0LateralSafeDistance.kpiPass.yAxis.length === 0)) {
                    props.updateL0LateralSafeDistanceKPI(payload);
                }
        }
    };

    const loadLevel0LongitudinalKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_longitudinal_safe_distance_kpi') {
            if((props.levelZero.l0LongitudinalSafeDistance.longitudinalSafeDistance.xAxis.length === 0 &&
                props.levelZero.l0LongitudinalSafeDistance.longitudinalSafeDistance.yAxis.length === 0) && (
                props.levelZero.l0LongitudinalSafeDistance.longitudinalGapWithTV.xAxis.length === 0 &&
                props.levelZero.l0LongitudinalSafeDistance.longitudinalGapWithTV.yAxis.length === 0) && (
                props.levelZero.l0LongitudinalSafeDistance.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0LongitudinalSafeDistance.kpiPass.yAxis.length === 0)) {
                    props.updateL0LongitudinalSafeDistanceKPI(payload);
                }
        }
    };

    const loadLevel0OffRoadKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_offroad_check_kpi') {
            if((props.levelZero.l0OffRoadCheck.laneOffset.xAxis.length === 0 &&
                props.levelZero.l0OffRoadCheck.laneOffset.yAxis.length === 0) && (
                props.levelZero.l0OffRoadCheck.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0OffRoadCheck.kpiPass.yAxis.length === 0)) {
                    props.updateL0OffRoadCheckKPI(payload);
                }
        }
    };

    const loadLevel0LaneMarkingKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_lane_marking_check_kpi') {
            if((props.levelZero.l0LaneMarkingCheckKPI.laneOffset.xAxis.length === 0 &&
                props.levelZero.l0LaneMarkingCheckKPI.laneOffset.yAxis.length === 0) && (
                props.levelZero.l0LaneMarkingCheckKPI.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0LaneMarkingCheckKPI.kpiPass.yAxis.length === 0)) {
                    props.updateL0LaneMarkingCheckKPI(payload);
                }
        }
    };

    const loadLevel0IndicatorCheckingKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_indicator_checking_kpi') {
            if((props.levelZero.l0IndicatorCheckKPI.laneOffset.xAxis.length === 0 &&
                props.levelZero.l0IndicatorCheckKPI.laneOffset.yAxis.length === 0) && (
                props.levelZero.l0IndicatorCheckKPI.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0IndicatorCheckKPI.kpiPass.yAxis.length === 0)) {
                    props.updateL0IndicatorCheckingKPI(payload);
                }
        }
    };

    const loadLevel0SpeedLimitKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_speed_limit_check_kpi') {
            if((props.levelZero.l0SpeedLimitCheckKPI.speedLimit.xAxis.length === 0 &&
                props.levelZero.l0SpeedLimitCheckKPI.speedLimit.yAxis.length === 0) && (
                props.levelZero.l0SpeedLimitCheckKPI.egoVelocityY.xAxis.length === 0 &&
                props.levelZero.l0SpeedLimitCheckKPI.egoVelocityY.yAxis.length === 0) && (
                props.levelZero.l0SpeedLimitCheckKPI.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0SpeedLimitCheckKPI.kpiPass.yAxis.length === 0)) {
                    props.updateL0SpeedLimitCheckKPI(payload)
                }
        }
    };

    const loadLevel0FalseIndicatorKPIGraph = (kpi, payload) => {
        if(kpi.value === 'l0_false_indicator_check_kpi') {
            if((props.levelZero.l0FalseIndicatorCheckKPI.laneOffset.xAxis.length === 0 &&
                props.levelZero.l0FalseIndicatorCheckKPI.laneOffset.yAxis.length === 0) && (
                props.levelZero.l0FalseIndicatorCheckKPI.kpiPass.xAxis.length === 0 &&
                props.levelZero.l0FalseIndicatorCheckKPI.kpiPass.yAxis.length === 0)) {
                    props.updateL0FalseIndicatorCheckKPI(payload);
                }
        }
    };

    const loadRSSKPIGraph = (kpi, payload) => {
        loadRSSLongitudinalKPIGraph(kpi, payload);
        loadRSSLateralLeftKPIGraph(kpi, payload);
        loadRSSLateralRightKPIGraph(kpi, payload);
    };

    const loadRSSLongitudinalKPIGraph = (kpi, payload) => {
        if(kpi.value === 'rss_longitudinal_safe_check_kpi') {
            if((props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalCurrent.xAxis.length === 0 &&
                props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalCurrent.yAxis.length === 0) && (
                props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalSafe.xAxis.length === 0 &&
                props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalSafe.yAxis.length === 0) && (
                props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalFlag.xAxis.length === 0 &&
                props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalFlag.yAxis.length === 0) && (
                props.rss.rssLongitudinalSafeCheckKPI.overallRSSFlag.xAxis.length === 0 &&
                props.rss.rssLongitudinalSafeCheckKPI.overallRSSFlag.yAxis.length === 0)) {
                    props.updateRSSLongitudinalSafeCheckKPI(payload);
                }
        }
    };

    const loadRSSLateralLeftKPIGraph = (kpi, payload) => {
        if(kpi.value === 'rss_lateral_left_safe_check_kpi') {
            if((props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftCurrent.xAxis.length === 0 &&
                props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftCurrent.yAxis.length === 0) && (
                props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftSafe.xAxis.length === 0 &&
                props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftSafe.yAxis.length === 0) && (
                props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftFlag.xAxis.length === 0 &&
                props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftFlag.yAxis.length === 0) && (
                props.rss.rssLateralLeftSafeCheckKPI.overallRSSFlag.xAxis.length === 0 &&
                props.rss.rssLateralLeftSafeCheckKPI.overallRSSFlag.yAxis.length === 0)) {
                    props.updateRSSLateralLeftSafeCheckKPI(payload);
                }
        }
    };

    const loadRSSLateralRightKPIGraph = (kpi, payload) => {
        if(kpi.value === 'rss_lateral_right_safe_check_kpi') {
            if ((props.rss.rssLateralRightSafeCheckKPI.rssLateralRightCurrent.xAxis.length === 0 &&
                props.rss.rssLateralRightSafeCheckKPI.rssLateralRightCurrent.yAxis.length === 0) && (
                props.rss.rssLateralRightSafeCheckKPI.rssLateralRightSafe.xAxis.length === 0 &&
                props.rss.rssLateralRightSafeCheckKPI.rssLateralRightSafe.yAxis.length === 0) && (
                props.rss.rssLateralRightSafeCheckKPI.rssLateralRightFlag.xAxis.length === 0 &&
                props.rss.rssLateralRightSafeCheckKPI.rssLateralRightFlag.yAxis.length === 0) && (
                props.rss.rssLateralRightSafeCheckKPI.overallRSSFlag.xAxis.length === 0 &&
                props.rss.rssLateralRightSafeCheckKPI.overallRSSFlag.yAxis.length === 0)) {
                    props.updateRSSLateralRightSafeCheckKPI(payload);
                }
        }
    };

    const loadGraphData = (kpi, option) => {
        if(kpi && kpi.label) {
            if(option === 'one'){
                setGraphOne(kpi);
            } else {
                setGraphTwo(kpi);
            }

            // Payload to Send it to "Server"
            const payload = {
                bench_name: props.bench,
                test_run_id: props.testRunId,
                scenario_uuid: props.scenarioUUID,
                kpi_name: kpi.value
            }

            loadTJAKPIGraph(kpi, payload);
            loadLevel1KPIGraph(kpi, payload);
            loadLevel0KPIGraph(kpi, payload);
            loadRSSKPIGraph(kpi, payload);

//            if (kpi.value === 'lane_management_kpi') {
//                if((props.laneAvailability.availability === 0 && props.laneAvailability.nonAvailability === 0) &&
//                (props.laneOffset.xAxis.length === 0 && props.laneOffset.yAxis.length === 0 )) {
//                        props.updateLaneManagementKPI(payload);
//                }
//            } else if (kpi.value === 'longitudinal_motion_kpi') {
//                if((props.jerks.xAxis.length === 0 && props.jerks.yAxis.length === 0) &&
//                (props.acceleration.xAxis.length === 0 && props.acceleration.yAxis.length === 0)) {
//                    props.updateLongitudinalMotionKPI(payload);
//                }
//            } else if(kpi.value === 'safe_driving_kpi') {
//                if((props.timeToCollision.xAxis.length === 0 && props.timeToCollision.yAxis.length === 0) &&
//                (props.relativeDistance.xAxis.length === 0 && props.relativeDistance.yAxis.length === 0)) {
//                    props.updateSafeDrivingKPI(payload);
//                }
//            } else if(kpi.value === 'ego_velocity') {
//                if((props.egoVelocity.xAxis.length === 0 && props.egoVelocity.yAxis.length === 0) &&
//                (props.targetVelocity.xAxis.length === 0 && props.targetVelocity.yAxis.length === 0)) {
//                    props.updateEgoVelocityKPI(payload);
//                }
//            } else if(kpi.value === 'l1_lateral_acceleration_kpi') {
//                if((props.levelOne.l1LateralAcceleration.egoAcceleration.xAxis.length === 0 &&
//                    props.levelOne.l1LateralAcceleration.egoAcceleration.yAxis.length === 0) && (
//                    props.levelOne.l1LateralAcceleration.kpiPass.xAxis.length === 0 &&
//                    props.levelOne.l1LateralAcceleration.kpiPass.yAxis.length === 0 )) {
//                        props.updateL1LateralAccelerationKPI(payload);
//                    }
//            } else if(kpi.value === 'l1_lateral_jerk_kpi') {
//                if((props.levelOne.l1LateralJerk.lateralJerk.xAxis.length === 0 &&
//                    props.levelOne.l1LateralJerk.lateralJerk.yAxis.length === 0) && (
//                    props.levelOne.l1LateralJerk.kpiPass.xAxis.length === 0 &&
//                    props.levelOne.l1LateralJerk.kpiPass.yAxis.length === 0 )) {
//                        props.updateL1LateralJerkKPI(payload);
//                    }
//            } else if(kpi.value === 'l1_longitudinal_deceleration_kpi') {
//                if((props.levelOne.l1LongitudinalDeceleration.egoAccelerationX.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalDeceleration.egoAccelerationX.yAxis.length === 0) && (
//                    props.levelOne.l1LongitudinalDeceleration.kpiPass.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalDeceleration.kpiPass.yAxis.length === 0 )) {
//                        props.updateL1LongitudinalDecelerationKPI(payload);
//                    }
//            } else if(kpi.value === 'l1_longitudinal_acceleration_kpi') {
//                if((props.levelOne.l1LongitudinalAcceleration.egoAccelerationX.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalAcceleration.egoAccelerationX.yAxis.length === 0) && (
//                    props.levelOne.l1LongitudinalAcceleration.kpiPass.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalAcceleration.kpiPass.yAxis.length === 0 )) {
//                        props.updateL1LongitudinalAccelerationKPI(payload);
//                    }
//            } else if(kpi.value === 'l1_longitudinal_jerk_kpi') {
//                if((props.levelOne.l1LongitudinalJerk.longitudinalJerk.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalJerk.longitudinalJerk.yAxis.length === 0) && (
//                    props.levelOne.l1LongitudinalJerk.kpiPass.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalJerk.kpiPass.yAxis.length === 0 )) {
//                        props.updateL1LongitudinalJerkKPI(payload);
//                    }
//            } else if(kpi.value === 'l1_longitudinal_velocity_drop_kpi') {
//                if((props.levelOne.l1LongitudinalVelocityDrop.egoVelocityXDrop.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalVelocityDrop.egoVelocityXDrop.yAxis.length === 0) && (
//                    props.levelOne.l1LongitudinalVelocityDrop.egoAccelerationX.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalVelocityDrop.egoAccelerationX.yAxis.length === 0) && (
//                    props.levelOne.l1LongitudinalVelocityDrop.kpiPass.xAxis.length === 0 &&
//                    props.levelOne.l1LongitudinalVelocityDrop.kpiPass.yAxis.length === 0 )) {
//                        props.updateL1LongitudinalVelocityDropKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_collision_check_kpi') {
//                if((props.levelZero.l0CollisionCheck.longitudinalGapWithTV.xAxis.length === 0 &&
//                    props.levelZero.l0CollisionCheck.longitudinalGapWithTV.yAxis.length === 0) && (
//                    props.levelZero.l0CollisionCheck.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0CollisionCheck.kpiPass.yAxis.length === 0)) {
//                        props.updateL0CollisionCheckKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_lateral_safe_distance_kpi') {
//                if((props.levelZero.l0LateralSafeDistance.lateralGapWithTV.xAxis.length === 0 &&
//                    props.levelZero.l0LateralSafeDistance.lateralGapWithTV.yAxis.length === 0) && (
//                    props.levelZero.l0LateralSafeDistance.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0LateralSafeDistance.kpiPass.yAxis.length === 0)) {
//                        props.updateL0LateralSafeDistanceKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_longitudinal_safe_distance_kpi') {
//                if((props.levelZero.l0LongitudinalSafeDistance.longitudinalSafeDistance.xAxis.length === 0 &&
//                    props.levelZero.l0LongitudinalSafeDistance.longitudinalSafeDistance.yAxis.length === 0) && (
//                    props.levelZero.l0LongitudinalSafeDistance.longitudinalGapWithTV.xAxis.length === 0 &&
//                    props.levelZero.l0LongitudinalSafeDistance.longitudinalGapWithTV.yAxis.length === 0) && (
//                    props.levelZero.l0LongitudinalSafeDistance.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0LongitudinalSafeDistance.kpiPass.yAxis.length === 0)) {
//                        props.updateL0LongitudinalSafeDistanceKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_offroad_check_kpi') {
//                if((props.levelZero.l0OffRoadCheck.laneOffset.xAxis.length === 0 &&
//                    props.levelZero.l0OffRoadCheck.laneOffset.yAxis.length === 0) && (
//                    props.levelZero.l0OffRoadCheck.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0OffRoadCheck.kpiPass.yAxis.length === 0)) {
//                        props.updateL0OffRoadCheckKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_lane_marking_check_kpi') {
//                if((props.levelZero.l0LaneMarkingCheckKPI.laneOffset.xAxis.length === 0 &&
//                    props.levelZero.l0LaneMarkingCheckKPI.laneOffset.yAxis.length === 0) && (
//                    props.levelZero.l0LaneMarkingCheckKPI.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0LaneMarkingCheckKPI.kpiPass.yAxis.length === 0)) {
//                        props.updateL0LaneMarkingCheckKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_indicator_checking_kpi') {
//                if((props.levelZero.l0IndicatorCheckKPI.laneOffset.xAxis.length === 0 &&
//                    props.levelZero.l0IndicatorCheckKPI.laneOffset.yAxis.length === 0) && (
//                    props.levelZero.l0IndicatorCheckKPI.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0IndicatorCheckKPI.kpiPass.yAxis.length === 0)) {
//                        props.updateL0IndicatorCheckingKPI(payload);
//                    }
//            } else if(kpi.value === 'l0_speed_limit_check_kpi') {
//                if((props.levelZero.l0SpeedLimitCheckKPI.speedLimit.xAxis.length === 0 &&
//                    props.levelZero.l0SpeedLimitCheckKPI.speedLimit.yAxis.length === 0) && (
//                    props.levelZero.l0SpeedLimitCheckKPI.egoVelocityY.xAxis.length === 0 &&
//                    props.levelZero.l0SpeedLimitCheckKPI.egoVelocityY.yAxis.length === 0) && (
//                    props.levelZero.l0SpeedLimitCheckKPI.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0SpeedLimitCheckKPI.kpiPass.yAxis.length === 0)) {
//                        props.updateL0SpeedLimitCheckKPI(payload)
//                    }
//            } else if(kpi.value == 'l0_false_indicator_check_kpi') {
//                if((props.levelZero.l0FalseIndicatorCheckKPI.laneOffset.xAxis.length === 0 &&
//                    props.levelZero.l0FalseIndicatorCheckKPI.laneOffset.yAxis.length === 0) && (
//                    props.levelZero.l0FalseIndicatorCheckKPI.kpiPass.xAxis.length === 0 &&
//                    props.levelZero.l0FalseIndicatorCheckKPI.kpiPass.yAxis.length === 0)) {
//                        props.updateL0FalseIndicatorCheckKPI(payload);
//                    }
//            } else if(kpi.value == 'rss_longitudinal_safe_check_kpi') {
//                if((props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalCurrent.xAxis.length === 0 &&
//                    props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalCurrent.yAxis.length === 0) && (
//                    props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalSafe.xAxis.length === 0 &&
//                    props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalSafe.yAxis.length === 0) && (
//                    props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalFlag.xAxis.length === 0 &&
//                    props.rss.rssLongitudinalSafeCheckKPI.rssLongitudinalFlag.yAxis.length === 0) && (
//                    props.rss.rssLongitudinalSafeCheckKPI.overallRSSFlag.xAxis.length === 0 &&
//                    props.rss.rssLongitudinalSafeCheckKPI.overallRSSFlag.yAxis.length === 0)) {
//                        props.updateRSSLongitudinalSafeCheckKPI(payload);
//                    }
//            } else if(kpi.value == 'rss_lateral_left_safe_check_kpi') {
//                if((props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftCurrent.xAxis.length === 0 &&
//                    props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftCurrent.yAxis.length === 0) && (
//                    props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftSafe.xAxis.length === 0 &&
//                    props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftSafe.yAxis.length === 0) && (
//                    props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftFlag.xAxis.length === 0 &&
//                    props.rss.rssLateralLeftSafeCheckKPI.rssLateralLeftFlag.yAxis.length === 0) && (
//                    props.rss.rssLateralLeftSafeCheckKPI.overallRSSFlag.xAxis.length === 0 &&
//                    props.rss.rssLateralLeftSafeCheckKPI.overallRSSFlag.yAxis.length === 0)) {
//                        props.updateRSSLateralLeftSafeCheckKPI(payload);
//                    }
//            } else if(kpi.value === 'rss_lateral_right_safe_check_kpi') {
//                if ((props.rss.rssLateralRightSafeCheckKPI.rssLateralRightCurrent.xAxis.length === 0 &&
//                    props.rss.rssLateralRightSafeCheckKPI.rssLateralRightCurrent.yAxis.length === 0) && (
//                    props.rss.rssLateralRightSafeCheckKPI.rssLateralRightSafe.xAxis.length === 0 &&
//                    props.rss.rssLateralRightSafeCheckKPI.rssLateralRightSafe.yAxis.length === 0) && (
//                    props.rss.rssLateralRightSafeCheckKPI.rssLateralRightFlag.xAxis.length === 0 &&
//                    props.rss.rssLateralRightSafeCheckKPI.rssLateralRightFlag.yAxis.length === 0) && (
//                    props.rss.rssLateralRightSafeCheckKPI.overallRSSFlag.xAxis.length === 0 &&
//                    props.rss.rssLateralRightSafeCheckKPI.overallRSSFlag.yAxis.length === 0)) {
//                        props.updateRSSLateralRightSafeCheckKPI(payload);
//                    }
//            }
        }
    }

    const onGraphOneChange = (kpiOne, option) => {
        if(kpiOne && kpiOne.label) {
            loadGraphData(kpiOne, option);
        }
    }

    const onGraphTwoChange = (kpiTwo, option) => {
        if(kpiTwo && kpiTwo.label) {
            loadGraphData(kpiTwo, option);
        }
    }

    const renderTJAKPI = (graph) => (
            <>
                { (graph && graph.value === 'lane_management_kpi') && <LaneManagementKPI /> }
                { (graph && graph.value === 'longitudinal_motion_kpi') && <LongitudinalMotionKPI /> }
                { (graph && graph.value === 'safe_driving_kpi') && <SafeDrivingKPI /> }
                { (graph && graph.value === 'ego_velocity') && <EgoVelocityKPI /> }
            </>
    );

    const renderLevel0KPI = (graph) => (
        <>
            { (graph && graph.value === 'l0_collision_check_kpi') && <L0CollisionCheckKPI />}
            { (graph && graph.value === 'l0_lateral_safe_distance_kpi') && <L0LateralSafeDistanceKPI /> }
            { (graph && graph.value === 'l0_longitudinal_safe_distance_kpi') && <L0LongitudinalSafeDistanceKPI /> }
            { (graph && graph.value === 'l0_offroad_check_kpi') && <L0OffRoadCheckKPI /> }
            { (graph && graph.value === 'l0_lane_marking_check_kpi') && <L0LaneMarkingCheckKPI /> }
            { (graph && graph.value === 'l0_indicator_checking_kpi') && <L0IndicatorCheckKPI /> }
            { (graph && graph.value === 'l0_speed_limit_check_kpi') && <L0SpeedLimitCheckKPI /> }
            { (graph && graph.value === 'l0_false_indicator_check_kpi') && <L0FalseIndicatorCheckKPI /> }
        </>
    );

    const renderLevel1KPI = (graph) => (
        <>
            { (graph && graph.value === 'l1_lateral_acceleration_kpi') && <L1LateralAccelerationKPI /> }
            { (graph && graph.value === 'l1_lateral_jerk_kpi') && <L1LateralJerkKPI /> }
            { (graph && graph.value === 'l1_longitudinal_deceleration_kpi') && <L1LongitudinalDecelerationKPI /> }
            { (graph && graph.value === 'l1_longitudinal_acceleration_kpi') && <L1LongitudinalAccelerationKPI /> }
            { (graph && graph.value === 'l1_longitudinal_jerk_kpi') && <L1LongitudinalJerkKPI /> }
            { (graph && graph.value === 'l1_longitudinal_velocity_drop_kpi') && <L1LongitudinalVelocityDropKPI /> }
        </>
    );

    const renderRSSKPI = (graph) => (
        <>
            { (graph && graph.value === 'rss_longitudinal_safe_check_kpi') && <RSSLongitudinalSafeCheckKPI /> }
            { (graph && graph.value === 'rss_lateral_left_safe_check_kpi') && <RSSLateralLeftSafeCheckKPI /> }
            { (graph && graph.value === 'rss_lateral_right_safe_check_kpi') && <RSSLateralRightSafeCheckKPI /> }
        </>
    );

    return (
        <Container>
            { (props.tagName &&
                (props.groupId ||
                props.groupName) &&
                props.bench &&
                props.testRunId &&
                props.scenarioUUID) && (
                <Row>
                    <Col md={6} xl={6}>
                        <VirtualizedSelect
                            options={graphOptions}
                            onChange={(kpiOne) => { onGraphOneChange(kpiOne, 'one') }}
                            value={graphOne}
                        />
                    </Col>
                    <Col md={6} xl={6}>
                        <VirtualizedSelect
                            options={graphOptions}
                            onChange={(kpiTwo) => { onGraphTwoChange(kpiTwo, 'two') }}
                            value={graphTwo}
                        />
                    </Col>
                </Row>
                ) }
            <Row>
                <Col md={6} xl={6}>
                    { renderTJAKPI(graphOne) }
                    { renderLevel0KPI(graphOne) }
                    { renderLevel1KPI(graphOne) }
                    { renderRSSKPI(graphOne) }
                </Col>
                <Col md={6} xl={6}>
                    { renderTJAKPI(graphTwo) }
                    { renderLevel0KPI(graphTwo) }
                    { renderLevel1KPI(graphTwo) }
                    { renderRSSKPI(graphTwo) }
                </Col>
            </Row>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    tagName: state.dashboardFilterData.info.selectData.tagName,
    groupId: state.dashboardFilterData.info.selectData.scenarioGroupId,
    groupName: state.dashboardFilterData.info.selectData.scenarioGroupName,
    bench: state.dashboardFilterData.info.selectData.benchName,
    testRunId: state.dashboardFilterData.info.selectData.runId,
    scenarioUUID: state.dashboardFilterData.info.selectData.scenarioId,
    // Lane Management KPI
    laneAvailability: state.dashboardGraphData.laneManagementKPI.laneAvailability,
    laneOffset: state.dashboardGraphData.laneManagementKPI.laneOffset,

    // Longitudinal Motion KPI or Vehicle Motion KPI
    jerks: state.longitudinalMotion.longitudinalMotionKPI.jerks,
    acceleration: state.longitudinalMotion.longitudinalMotionKPI.acceleration,

    // Safe Driving KPI
    timeToCollision: state.safeDriving.safeDrivingKPI.timeToCollision,
    relativeDistance: state.safeDriving.safeDrivingKPI.relativeDistance,

    // Ego Velocity KPI
    egoVelocity: state.egoVelocity.egoVelocityKPI.egoVelocity,
    targetVelocity: state.egoVelocity.egoVelocityKPI.targetVelocity,

    // Level One KPI
    levelOne: {
        // Level 1 Lateral Acceleration KPI
        l1LateralAcceleration: {
            egoAcceleration: state.l1LateralAcceleration.l1LateralAccelerationKPI.egoAcceleration,
            kpiPass: state.l1LateralAcceleration.l1LateralAccelerationKPI.kpiPass
        },
        // Level 1 Lateral Jerk KPI
        l1LateralJerk: {
            lateralJerk: state.l1LateralJerk.l1LateralJerkKPI.lateralJerk,
            kpiPass: state.l1LateralJerk.l1LateralJerkKPI.kpiPass
        },
        // Level 1 Longitudinal Acceleration KPI
        l1LongitudinalAcceleration: {
            egoAccelerationX: state.l1LongitudinalAcceleration.l1LongitudinalAccelerationKPI.egoAccelerationX,
            kpiPass: state.l1LongitudinalAcceleration.l1LongitudinalAccelerationKPI.kpiPass
        },
        // Level 1 Longitudinal Deceleration KPI
        l1LongitudinalDeceleration: {
            egoAccelerationX: state.l1LongitudinalDeceleration.l1LongitudinalDecelerationKPI.egoAccelerationX,
            kpiPass: state.l1LongitudinalDeceleration.l1LongitudinalDecelerationKPI.kpiPass
        },
        // Level 1 Longitudinal Jerk KPI
        l1LongitudinalJerk: {
            longitudinalJerk: state.l1LongitudinalJerk.l1LongitudinalJerkKPI.longitudinalJerk,
            kpiPass: state.l1LongitudinalJerk.l1LongitudinalJerkKPI.kpiPass
        },
        // Level 1 Longitudinal Velocity Drop KPI
        l1LongitudinalVelocityDrop: {
            egoVelocityXDrop: state.l1LongitudinalVelocityDrop.l1LongitudinalVelocityDropKPI.egoVelocityXDrop,
            egoAccelerationX: state.l1LongitudinalVelocityDrop.l1LongitudinalVelocityDropKPI.egoAccelerationX,
            kpiPass: state.l1LongitudinalVelocityDrop.l1LongitudinalVelocityDropKPI.kpiPass
        }
    },
    levelZero: {
        // Level 0 Collision Check KPI
        l0CollisionCheck: {
            longitudinalGapWithTV: state.l0CollisionCheck.l0CollisionCheckKPI.longitudinalGapWithTV,
            kpiPass: state.l0CollisionCheck.l0CollisionCheckKPI.kpiPass
        },
        // Level 0 Lateral Safe Distance KPI
        l0LateralSafeDistance: {
            lateralGapWithTV: state.l0lateralSafeDistance.l0lateralSafeDistanceKPI.lateralGapWithTV,
            kpiPass: state.l0lateralSafeDistance.l0lateralSafeDistanceKPI.kpiPass
        },
        // Level 0 Longitudinal Safe Distance KPI
        l0LongitudinalSafeDistance: {
            longitudinalSafeDistance: state.l0LongitudinalSafeDistance.l0LongitudinalSafeDistanceKPI.longitudinalSafeDistance,
            longitudinalGapWithTV: state.l0LongitudinalSafeDistance.l0LongitudinalSafeDistanceKPI.longitudinalGapWithTV,
            kpiPass: state.l0LongitudinalSafeDistance.l0LongitudinalSafeDistanceKPI.kpiPass
        },
        // Level 0 Off Road Check KPI
        l0OffRoadCheck: {
            laneOffset: state.l0OffRoadCheck.l0OffRoadCheckKPI.laneOffset,
            kpiPass: state.l0OffRoadCheck.l0OffRoadCheckKPI.kpiPass
        },
        // Level 0 Lane Marking Check KPI
        l0LaneMarkingCheckKPI: {
            laneOffset: state.l0LaneMarkingCheck.l0LaneMarkingCheckKPI.laneOffset,
            kpiPass: state.l0LaneMarkingCheck.l0LaneMarkingCheckKPI.kpiPass
        },
        // Level 0 Indicator Checking KPI
        l0IndicatorCheckKPI: {
            laneOffset: state.l0IndicatorChecking.l0IndicatorCheckingKPI.laneOffset,
            kpiPass: state.l0IndicatorChecking.l0IndicatorCheckingKPI.kpiPass
        },
        // Level 0 Speed Limit Check KPI
        l0SpeedLimitCheckKPI: {
            speedLimit: state.l0SpeedLimitCheck.l0SpeedLimitCheckKPI.speedLimit,
            egoVelocityY: state.l0SpeedLimitCheck.l0SpeedLimitCheckKPI.egoVelocityY,
            kpiPass: state.l0SpeedLimitCheck.l0SpeedLimitCheckKPI.kpiPass
        },
        // Level 0 False Indicator Check KPI
        l0FalseIndicatorCheckKPI: {
            laneOffset: state.l0FalseIndicatorCheck.l0FalseIndicatorCheckKPI.laneOffset,
            kpiPass: state.l0FalseIndicatorCheck.l0FalseIndicatorCheckKPI.kpiPass
        }
    },
    rss: {
        // RSS Longitudinal Safe Check KPI
        rssLongitudinalSafeCheckKPI: {
            rssLongitudinalCurrent: state.rssLongitudinalSafeCheck.rssLongitudinalSafeCheckKPI.rssLongitudinalCurrent,
            rssLongitudinalSafe: state.rssLongitudinalSafeCheck.rssLongitudinalSafeCheckKPI.rssLongitudinalSafe,
            rssLongitudinalFlag: state.rssLongitudinalSafeCheck.rssLongitudinalSafeCheckKPI.rssLongitudinalFlag,
            overallRSSFlag: state.rssLongitudinalSafeCheck.rssLongitudinalSafeCheckKPI.overallRSSFlag
        },
        // RSS Lateral Left Safe Check KPI
        rssLateralLeftSafeCheckKPI: {
            rssLateralLeftCurrent: state.rssLateralLeftSafeCheck.rssLateralLeftSafeCheckKPI.rssLateralLeftCurrent,
            rssLateralLeftSafe: state.rssLateralLeftSafeCheck.rssLateralLeftSafeCheckKPI.rssLateralLeftSafe,
            rssLateralLeftFlag: state.rssLateralLeftSafeCheck.rssLateralLeftSafeCheckKPI.rssLateralLeftFlag,
            overallRSSFlag: state.rssLateralLeftSafeCheck.rssLateralLeftSafeCheckKPI.overallRSSFlag
        },
        // RSS Lateral Right Safe Check KPI
        rssLateralRightSafeCheckKPI: {
            rssLateralRightCurrent: state.rssLateralRightSafeCheck.rssLateralRightSafeCheckKPI.rssLateralRightCurrent,
            rssLateralRightSafe: state.rssLateralRightSafeCheck.rssLateralRightSafeCheckKPI.rssLateralRightSafe,
            rssLateralRightFlag: state.rssLateralRightSafeCheck.rssLateralRightSafeCheckKPI.rssLateralRightFlag,
            overallRSSFlag: state.rssLateralRightSafeCheck.rssLateralRightSafeCheckKPI.overallRSSFlag
        }
    }
})

const mapDispatchToProps = (dispatch) => ({
    updateLaneManagementKPI: (payload) => dispatch(updateLaneManagementKPIGraph(payload)),
    updateLongitudinalMotionKPI: (payload) => dispatch(updateLongitudinalMotionKPIGraph(payload)),
    updateSafeDrivingKPI: (payload) => dispatch(updateSafeDrivingKPIGraph(payload)),
    updateEgoVelocityKPI: (payload) => dispatch(updateEgoVelocityKPIGraph(payload)),
    updateL1LateralAccelerationKPI: (payload) => dispatch(updateL1LateralAccelerationKPIGraph(payload)),
    updateL1LateralJerkKPI: (payload) => dispatch(updateL1LateralJerkKPIGraph(payload)),
    updateL1LongitudinalAccelerationKPI: (payload) => dispatch(updateL1LongitudinalAccelerationKPIGraph(payload)),
    updateL1LongitudinalDecelerationKPI: (payload) => dispatch(updateL1LongitudinalDecelerationKPIGraph(payload)),
    updateL1LongitudinalJerkKPI: (payload) => dispatch(updateL1LongitudinalJerkKPIGraph(payload)),
    updateL1LongitudinalVelocityDropKPI: (payload) => dispatch(updateL1LongitudinalVelocityDropKPIGraph(payload)),
    updateL0CollisionCheckKPI: (payload) => dispatch(updateL0CollisionCheckKPIGraph(payload)),
    updateL0LateralSafeDistanceKPI: (payload) => dispatch(updateL0LateralSafeDistanceKPIGraph(payload)),
    updateL0LongitudinalSafeDistanceKPI: (payload) => dispatch(updateL0LongitudinalSafeDistanceKPIGraph(payload)),
    updateL0OffRoadCheckKPI: (payload) => dispatch(updateL0OffRoadCheckKPIGraph(payload)),
    updateL0LaneMarkingCheckKPI: (payload) => dispatch(updateL0LaneMarkingCheckKPIGraph(payload)),
    updateL0IndicatorCheckingKPI: (payload) => dispatch(updateL0IndicatorCheckingKPIGraph(payload)),
    updateL0SpeedLimitCheckKPI: (payload) => dispatch(updateL0SpeedLimitCheckKPIGraph(payload)),
    updateL0FalseIndicatorCheckKPI: (payload) => dispatch(updateL0FalseIndicatorCheckKPIGraph(payload)),
    updateRSSLongitudinalSafeCheckKPI: (payload) => dispatch(updateRSSLongitudinalSafeCheckKPIGraph(payload)),
    updateRSSLateralLeftSafeCheckKPI : (payload) => dispatch(updateRSSLateralLeftSafeCheckKPIGraph(payload)),
    updateRSSLateralRightSafeCheckKPI: (payload) => dispatch(updateRSSLateralRightSafeCheckKPIGraph(payload))
})

VisualizationTabs.propTypes={
    bench: PropTypes.string,
    testRunId: PropTypes.string,
    scenarioUUID: PropTypes.string,
    tagName: PropTypes.string,
    groupId: PropTypes.number,
    groupName: PropTypes.string,
    updateLaneManagementKPI: PropTypes.func,
    updateLongitudinalMotionKPI: PropTypes.func,
    updateSafeDrivingKPI: PropTypes.func,
    updateEgoVelocityKPI: PropTypes.func,
    updateL1LateralAccelerationKPI: PropTypes.func,
    updateL1LateralJerkKPI: PropTypes.func,
    updateL1LongitudinalAccelerationKPI: PropTypes.func,
    updateL1LongitudinalDecelerationKPI: PropTypes.func,
    updateL1LongitudinalJerkKPI: PropTypes.func,
    updateL1LongitudinalVelocityDropKPI: PropTypes.func,
    updateL0CollisionCheckKPI: PropTypes.func,
    updateL0LateralSafeDistanceKPI: PropTypes.func,
    updateL0LongitudinalSafeDistanceKPI: PropTypes.func,
    updateL0OffRoadCheckKPI: PropTypes.func,
    updateL0LaneMarkingCheckKPI: PropTypes.func,
    updateL0IndicatorCheckingKPI: PropTypes.func,
    updateL0SpeedLimitCheckKPI: PropTypes.func,
    updateL0FalseIndicatorCheckKPI: PropTypes.func,
    updateRSSLongitudinalSafeCheckKPI: PropTypes.func,
    updateRSSLateralLeftSafeCheckKPI : PropTypes.func,
    updateRSSLateralRightSafeCheckKPI: PropTypes.func,
    laneAvailability: PropTypes.shape({
        availability: PropTypes.number,
        nonAvailability: PropTypes.number
    }),
    laneOffset: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    jerks: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    acceleration: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    timeToCollision: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    relativeDistance: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    egoVelocity: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    targetVelocity: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    }),
    levelOne: PropTypes.shape({
        l1LateralJerk: PropTypes.shape({
            lateralJerk: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l1LateralAcceleration: PropTypes.shape({
            egoAcceleration: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l1LongitudinalDeceleration: PropTypes.shape({
            egoAccelerationX: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l1LongitudinalAcceleration: PropTypes.shape({
            egoAccelerationX: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l1LongitudinalJerk: PropTypes.shape({
            longitudinalJerk: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l1LongitudinalVelocityDrop: PropTypes.shape({
            egoVelocityXDrop: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            egoAccelerationX: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        })
    }),
    levelZero: PropTypes.shape({
        l0CollisionCheck: PropTypes.shape({
            longitudinalGapWithTV: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0LateralSafeDistance: PropTypes.shape({
            lateralGapWithTV: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0LongitudinalSafeDistance: PropTypes.shape({
            longitudinalSafeDistance: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            longitudinalGapWithTV: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0OffRoadCheck: PropTypes.shape({
            laneOffset: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0LaneMarkingCheckKPI: PropTypes.shape({
            laneOffset: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0IndicatorCheckKPI: PropTypes.shape({
            laneOffset: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0SpeedLimitCheckKPI: PropTypes.shape({
            speedLimit: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            egoVelocityY: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        l0FalseIndicatorCheckKPI: PropTypes.shape({
            laneOffset: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            kpiPass: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        })
    }),
    rss: PropTypes.shape({
        rssLongitudinalSafeCheckKPI: PropTypes.shape({
            rssLongitudinalCurrent: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            rssLongitudinalSafe: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            rssLongitudinalFlag: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            overallRSSFlag: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        rssLateralLeftSafeCheckKPI: PropTypes.shape({
            rssLateralLeftCurrent: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            rssLateralLeftSafe: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            rssLateralLeftFlag: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            overallRSSFlag: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        }),
        rssLateralRightSafeCheckKPI: PropTypes.shape({
            rssLateralRightCurrent: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            rssLateralRightSafe: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            rssLateralRightFlag: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            }),
            overallRSSFlag: PropTypes.shape({
                xAxis: PropTypes.array,
                yAxis: PropTypes.array
            })
        })
    })    
}

VisualizationTabs.defaultProps= {
    bench: '',
    testRunId: '',
    scenarioUUID: '',
    tagName: '',
    groupId: 0,
    groupName: '',
    laneAvailability: {
        availability: 0,
        nonAvailability: 0
    },
    laneOffset: {
        xAxis: [],
        yAxis: []
    },
    jerks: {
        xAxis: [],
        yAxis: []
    },
    acceleration: {
        xAxis: [],
        yAxis: []
    },
    timeToCollision: {
        xAxis: [],
        yAxis: []
    },
    relativeDistance: {
        xAxis: [],
        yAxis: []
    },
    egoVelocity: {
        xAxis: [],
        yAxis: []
    },
    targetVelocity: {
        xAxis: [],
        yAxis: []
    },
    levelOne:{
        l1LateralJerk: {
            lateralJerk: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l1LateralAcceleration: {
            egoAcceleration: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l1LongitudinalDeceleration: {
            egoAccelerationX: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l1LongitudinalAcceleration: {
            egoAccelerationX: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l1LongitudinalJerk: {
            longitudinalJerk: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l1LongitudinalVelocityDrop: {
            egoVelocityXDrop: {
                xAxis: [],
                yAxis: []
            },
            egoAccelerationX: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        }
    },
    levelZero: {
        l0CollisionCheck: {
            longitudinalGapWithTV: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0lateralSafeDistance: {
            lateralGapWithTV: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0LongitudinalSafeDistance: {
            longitudinalSafeDistance: {
                xAxis: [],
                yAxis: []
            },
            longitudinalGapWithTV: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0OffRoadCheck: {
            laneOffset: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0LaneMarkingCheckKPI: {
            laneOffset: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0IndicatorCheckKPI: {
            laneOffset: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0SpeedLimitCheckKPI: {
            speedLimit: {
                xAxis: [],
                yAxis: []
            },
            egoVelocityY: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        },
        l0FalseIndicatorCheckKPI: {
            laneOffset: {
                xAxis: [],
                yAxis: []
            },
            kpiPass: {
                xAxis: [],
                yAxis: []
            }
        }
    },
    rss: {
        rssLongitudinalSafeCheckKPI: {
            rssLongitudinalCurrent: {
                xAxis: [],
                yAxis: []
            },
            rssLongitudinalSafe: {
                xAxis: [],
                yAxis: []
            },
            rssLongitudinalFlag: {
                xAxis: [],
                yAxis: []
            },
            overallRSSFlag: {
                xAxis: [],
                yAxis: []
            }
        },
        rssLateralLeftSafeCheckKPI: {
            rssLateralLeftCurrent: {
                xAxis: [],
                yAxis: []
            },
            rssLateralLeftSafe: {
                xAxis: [],
                yAxis: []
            },
            rssLateralLeftFlag: {
                xAxis: [],
                yAxis: []
            },
            overallRSSFlag: {
                xAxis: [],
                yAxis: []
            }
        },
        rssLateralRightSafeCheckKPI: {
            rssLateralRightCurrent: {
                xAxis: [],
                yAxis: []
            },
            rssLateralRightSafe: {
                xAxis: [],
                yAxis: []
            },
            rssLateralRightFlag: {
                xAxis: [],
                yAxis: []
            },
            overallRSSFlag: {
                xAxis: [],
                yAxis: []
            }
        }
    }
}
    

export default connect(mapStateToProps, mapDispatchToProps)(VisualizationTabs);